import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ff04be8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between pb-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Перевозчик с таким БИН не найден!", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Отказано службой безопасности", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1))
const _hoisted_9 = {
  key: 2,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Компания не прошла проверку службы безопасности", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_14 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = { class: "flex items-center mt-3" }
const _hoisted_17 = { class: "flex justify-end items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("form", {
    class: "CarrierForm",
    onSubmit: _cache[31] || (_cache[31] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitManager && _ctx.emitManager(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, {
        title: _ctx.isCreate ? 'Добавление поставщика' : 'Редактирование поставщика'
      }, null, 8, ["title"]),
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _ctx.emitCancel
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createTextVNode(" Отмена ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_the_input, {
      placeholder: "БИН/ИИН/ИНН",
      value: _ctx.state.bin,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.bin) = $event)),
      "is-invalid": _ctx.state_form$.bin.$error,
      "validation-errors": _ctx.state_form$.bin.$errors,
      disabled: _ctx.sb_state.is_loading || _ctx.company_data.is_loaded || _ctx.isUpdate,
      onInput: _ctx.resetSbState
    }, null, 8, ["value", "is-invalid", "validation-errors", "disabled", "onInput"]),
    (_ctx.isNotFound)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.isRejected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("p", null, [
            _hoisted_7,
            _createTextVNode(" (" + _toDisplayString(_ctx.sb_state.reject_comment) + ") ", 1)
          ]),
          _hoisted_8
        ]))
      : _createCommentVNode("", true),
    (_ctx.isNotChecked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
      : _createCommentVNode("", true),
    (_ctx.step === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_the_input, {
              placeholder: "Название перевозчика",
              value: _ctx.state.name,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.name) = $event)),
              "is-invalid": _ctx.state_form$.name.$error,
              "validation-errors": _ctx.state_form$.name.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              placeholder: "Сокращенное название перевозчика",
              value: _ctx.state.shortName,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.shortName) = $event)),
              "is-invalid": _ctx.state_form$.shortName.$error,
              "validation-errors": _ctx.state_form$.shortName.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              placeholder: "КБЕ",
              value: _ctx.state.kbe,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.kbe) = $event)),
              "is-invalid": _ctx.state_form$.kbe.$error,
              "validation-errors": _ctx.state_form$.kbe.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_select, {
              value: _ctx.state.type,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.type) = $event)),
              placeholder: "Выберите тип перевозчика",
              "is-invalid": _ctx.state_form$.type.$error,
              "validation-errors": _ctx.state_form$.type.$errors,
              loading: false,
              options: _ctx.CarriersTypes,
              "search-by": "name",
              label: "name"
            }, null, 8, ["value", "is-invalid", "validation-errors", "options"]),
            _createVNode(_component_the_select, {
              value: _ctx.state.transportTypeIds,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.transportTypeIds) = $event)),
              placeholder: "Выберите типы транспорта",
              loading: _ctx.data_state.transport_types.is_loading,
              options: _ctx.data_state.transport_types.list,
              failed: _ctx.data_state.transport_types.is_failed,
              "error-text": "При получении списка произошла ошибка",
              "infinite-scroll": "",
              multiselect: "",
              onRefresh: _ctx.loadTransportTypes
            }, null, 8, ["value", "loading", "options", "failed", "onRefresh"]),
            _createVNode(_component_the_select, {
              value: _ctx.state.countryId,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.countryId) = $event)),
              placeholder: "Выберите страну резидентства",
              "is-invalid": _ctx.state_form$.countryId.$error,
              "validation-errors": _ctx.state_form$.countryId.$errors,
              loading: _ctx.data_state.countries.is_loading,
              options: _ctx.data_state.countries.list,
              failed: _ctx.data_state.countries.is_failed,
              "error-text": "При получении списка стран произошла ошибка",
              "search-by": "title",
              "select-by": "id",
              label: "title",
              "infinite-scroll": "",
              onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadCountries(_ctx.data_state.countries.pagination.current_page))),
              onLoadmore: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadMoreCountries(_ctx.data_state.countries.pagination.current_page + 1))),
              onSearch: _ctx.searchCountries,
              onOptionBySearch: _ctx.unshiftFindedCountry
            }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
            _createVNode(_component_the_input, {
              placeholder: "Юридический адрес",
              value: _ctx.state.jurAddress,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.jurAddress) = $event)),
              "is-invalid": _ctx.state_form$.jurAddress.$error,
              "validation-errors": _ctx.state_form$.jurAddress.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              placeholder: "Фактический адрес",
              value: _ctx.state.factAddress,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.factAddress) = $event)),
              "is-invalid": _ctx.state_form$.factAddress.$error,
              "validation-errors": _ctx.state_form$.factAddress.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              placeholder: "Банковский счёт",
              value: _ctx.state.bankAccount,
              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.bankAccount) = $event)),
              "is-invalid": _ctx.state_form$.bankAccount.$error,
              "validation-errors": _ctx.state_form$.bankAccount.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              placeholder: "Название банка",
              value: _ctx.state.bank,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.bank) = $event)),
              "is-invalid": _ctx.state_form$.bank.$error,
              "validation-errors": _ctx.state_form$.bank.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              placeholder: "БИК",
              value: _ctx.state.bik,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.bik) = $event)),
              "is-invalid": _ctx.state_form$.bik.$error,
              "validation-errors": _ctx.state_form$.bik.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              placeholder: "Номер договора",
              value: _ctx.state.contractNumber,
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.contractNumber) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_the_input, {
              placeholder: "Дата договора",
              type: "date",
              value: _ctx.state.contractDate,
              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.contractDate) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_the_input, {
              placeholder: "Контактное имя",
              value: _ctx.state.contactName,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.contactName) = $event)),
              "is-invalid": _ctx.state_form$.contactName.$error,
              "validation-errors": _ctx.state_form$.contactName.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              placeholder: "Контактный телефон",
              value: _ctx.state.contactPhone,
              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.contactPhone) = $event)),
              "is-invalid": _ctx.state_form$.contactPhone.$error,
              "validation-errors": _ctx.state_form$.contactPhone.$errors,
              maska: _ctx.PHONE_NUMBER_MASK
            }, null, 8, ["value", "is-invalid", "validation-errors", "maska"]),
            _createVNode(_component_the_input, {
              placeholder: "Почта подписанта",
              "is-invalid": _ctx.state_form$.contactEmail.$error,
              "validation-errors": _ctx.state_form$.contactEmail.$errors,
              value: _ctx.state.contactEmail,
              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.contactEmail) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_select, {
              value: _ctx.state.logistId,
              "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.logistId) = $event)),
              placeholder: "Логист",
              "is-invalid": _ctx.state_form$.logistId.$error,
              "validation-errors": _ctx.state_form$.logistId.$errors,
              loading: _ctx.data_state.logists.is_loading,
              options: _ctx.data_state.logists.list,
              failed: _ctx.data_state.logists.is_failed,
              "error-text": "При получении списка логистов произошла ошибка",
              "search-by": "name",
              "select-by": "id",
              label: "name",
              "infinite-scroll": "",
              onRefresh: _cache[20] || (_cache[20] = ($event: any) => (_ctx.loadLogists(_ctx.data_state.logists.pagination.current_page))),
              onLoadmore: _cache[21] || (_cache[21] = ($event: any) => (_ctx.loadMoreLogists(_ctx.data_state.logists.pagination.current_page + 1))),
              onSearch: _ctx.searchLogists,
              onOptionBySearch: _ctx.unshiftFindedLogist
            }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
            _createVNode(_component_the_select, {
              value: _ctx.state.cities,
              "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.cities) = $event)),
              placeholder: "Выберите города оказания услуг",
              "is-invalid": _ctx.state_form$.cities.$error,
              "validation-errors": _ctx.state_form$.cities.$errors,
              loading: _ctx.data_state.cities.is_loading,
              options: _ctx.data_state.cities.list,
              failed: _ctx.data_state.cities.is_failed,
              "error-text": "При получении списка городов произошла ошибка",
              "search-by": "name",
              "select-by": "id",
              label: "name",
              multiselect: "",
              "infinite-scroll": "",
              onRefresh: _cache[23] || (_cache[23] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
              onLoadmore: _cache[24] || (_cache[24] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
              onSearch: _ctx.searchCity,
              onOptionBySearch: _ctx.unshiftFindedCity
            }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
            (_ctx.isUpdate)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 0,
                  placeholder: "Код 1С",
                  value: _ctx.state.code1C,
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.code1C) = $event))
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_checkbox, {
                value: _ctx.state.typeTons,
                "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.typeTons) = $event)),
                label: "Менее 3-х тонн",
                "return-integer": "",
                disabled: _ctx.state.isStandardContract
              }, null, 8, ["value", "disabled"])
            ]),
            _createVNode(_component_the_select, {
              value: _ctx.state.activityIds,
              "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.activityIds) = $event)),
              placeholder: "Тип перевозчика",
              "is-invalid": _ctx.state_form$.activityIds.$error,
              "validation-errors": _ctx.state_form$.activityIds.$errors,
              options: _ctx.CARRIER_TYPES,
              multiselect: ""
            }, null, 8, ["value", "is-invalid", "validation-errors", "options"]),
            (_ctx.state.activityIds.includes(2))
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 1,
                  placeholder: "ОКЭД",
                  value: _ctx.state.economicActivityClassifier,
                  "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.economicActivityClassifier) = $event)),
                  "is-invalid": _ctx.state_form$.economicActivityClassifier.$error,
                  "validation-errors": _ctx.state_form$.economicActivityClassifier.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_checkbox, {
              value: _ctx.state.isStandardContract,
              "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.isStandardContract) = $event)),
              disabled: _ctx.state.typeTons === 1,
              label: "Стандартный договор"
            }, null, 8, ["value", "disabled"]),
            _createVNode(_component_checkbox, {
              value: _ctx.state.isNds,
              "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.isNds) = $event)),
              label: "С НДС",
              class: "ml-3"
            }, null, 8, ["value"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      (_ctx.step === 1)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            class: "submit-btn small primary",
            type: "submit",
            loading: 
                    _ctx.sb_state.is_loading ||
                    _ctx.company_data.is_loading ||
                    _ctx.company_data.is_information_loading
                
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Проверить ")
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true),
      (_ctx.step === 2)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 1,
            class: "submit-btn small primary",
            type: "submit",
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isCreate ? 'Создать' : 'Редактировать'), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}